<script lang="ts" setup>
import type {
    CollectionFragment,
    MetadataFragment,
} from '~/lib/graphql/graphql.ts'

const props = defineProps<{
  item: MetadataFragment | CollectionFragment
}>()

const author = computed(() => {
    return getAuthor(props.item)
})
</script>

<template>
  <div class="max-w-[1271px] pt-2 md:ps-8 md:pt-4 md:pe-8 lg:ps-4 lg:pe-4 m-auto">
    <div class="mt-4 md:mt-8 font-serif">
      <BadgesBadge
        :item="item"
        class="justify-items-center mb-6 text-lg text-center"
      />
      <div class="prose flex justify-center m-auto">
        <h1
          class="h1 p-0 m-0 px-2 text-3xl md:text-5xl text-center"
          style="margin-bottom: 16px"
        >
          {{ item.name }}
        </h1>
      </div>
      <slot name="author">
        <PLink
          v-if="author"
          id="header-author"
          :to="'/people/' + author.slug"
          :content="[{ id: item.id, type: item.__typename || [] }]"
          :extras="{ slug: author.slug, author: author.id }"
          class="flex text-center text-neutral-500 justify-center items-center pt-4"
        >
          <div>
            <ContentImage
              class="w-6 h-6 rounded-full object-cover me-2"
              :item="author"
              relationship="image.featured.square"
            />
          </div>
          <div class="text-neutral-700 font-sans">
            {{ author.name }}
          </div>
        </PLink>
      </slot>
    </div>
  </div>
</template>
